import { render, staticRenderFns } from "./TvappSearch.vue?vue&type=template&id=01129060&scoped=true&"
import script from "./TvappSearch.vue?vue&type=script&lang=js&"
export * from "./TvappSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01129060",
  null
  
)

component.options.__file = "TvappSearch.vue"
export default component.exports